import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';

// CRA doesn't strip console.* calls from production builds, and this codebase logs
// liberally for debugging (including full API request/response payloads — see
// Docs/pre-production-checklist.md). Silence the debug-oriented console methods in
// production so that data isn't sitting in plain view for anyone with devtools open
// on a shared/kiosk machine. console.error/console.warn are left intact — they're
// the only production error visibility this app has (see the checklist's
// "no observability" item).
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
  // eslint-disable-next-line no-console
  console.debug = () => {};
  // eslint-disable-next-line no-console
  console.info = () => {};

  // console.error/console.warn stay on, but ~250 call sites across the app log a
  // caught axios error object directly (e.g. `console.error('...', error)`). An
  // axios error's `.config.data`/`.config.params` is the outgoing request body, and
  // `.response.data` is the full response body — concretely, a failed login logs
  // the plaintext password the user just typed (UserContext.js's login() posts
  // { userName, password }, and that request body rides along on the thrown error).
  // Reduce any Error-shaped argument to just name/message/HTTP status before it
  // reaches the console, in place, so every existing call site is covered without
  // editing each one individually.
  const sanitizeForConsole = (arg) => {
    if (arg instanceof Error) {
      const sanitized = { name: arg.name, message: arg.message };
      if (arg.response) {
        sanitized.status = arg.response.status;
        sanitized.statusText = arg.response.statusText;
      }
      return sanitized;
    }
    return arg;
  };

  const originalError = console.error;
  const originalWarn = console.warn;
  // eslint-disable-next-line no-console
  console.error = (...args) => originalError(...args.map(sanitizeForConsole));
  // eslint-disable-next-line no-console
  console.warn = (...args) => originalWarn(...args.map(sanitizeForConsole));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();